import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TitleTranslation } from './title-translation.const';

@Injectable({
  providedIn: 'root',
})
export class TabTitleService {
  private router = inject(Router);
  private title = inject(Title);
  private translate = inject(TranslateService);

  setupTabTitles(): void {
    this.subscribeToRouterEvents();
  }

  setTabTitle(url: string): void {
    let entityName = url.split('/')[1];
    entityName = entityName.charAt(0).toUpperCase() + entityName.slice(1);

    if (TitleTranslation[entityName]) {
      this.title.setTitle(
        this.translate.instant(TitleTranslation[entityName]) + ' - ViaTracks'
      );
    }
  }

  private subscribeToRouterEvents(): void {
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        this.setTabTitle(evt.url);
      }
    });
  }
}
